module.exports = __webpack_public_path__ + "img/a2.135113fe.png";